<template>
  <div>
    <div class="cert-header d-flex py-5">
      <div class="col-12 col-md-11 col-lg-10 col-xl-9 px-3 p-md-0 mx-auto">
        <div class="cert-title cert-large">Rw-Cert RFC 2350</div>
        <div class="cert-subtitle">Version 1.0 - September 2022</div>
      </div>
    </div>
    <div ref="content" class="col-12 col-md-11 col-lg-10 col-xl-8 p-2 p-sm-5 mx-auto mt-2 mt-sm-5 cert-page-content">
      <div class="cert-article">
        <h3><span class="cert-number">1.</span> About This Document</h3>
        <p>This document contains a description of Rw-CSIRT in accordance with <strong><a
            href="//www.rfc-editor.org/rfc/rfc2350">RFC 2350</a></strong>. It provides basic
          information about Rw-CSIRT, its channels of communication, and its roles and responsibilities.</p>

        <h4><span class="cert-number">1.1.</span>Date of Last Update</h4>
        <p>This is version 1.0, published on 30 June 2022 and updated on 15 September 2022.</p>

        <h4><span class="cert-number">1.2.</span>Distribution List for Notifications</h4>
        <p>Rw-CSIRT does not use any distribution lists to notify about changes in this document. This document
          is kept up to date at the location specified in <strong><a href="#1.3.">1.3.</a></strong></p>

        <h4 id="1.3."><span class="cert-number">1.3</span>Where This Document May Be Found</h4>
        <p>The current and latest version of this document is available through the following link
          <router-link :to="{path: '/rfc'}" style="font-weight: 600">http://172.16.32.134:8080/rfc</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "AlertDetails",
  components: {},
  data() {
    return {};
  },
};
</script>